/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_ASSET_DETAIL = gql`
query Query($tokenId: String!, $storeId: String!) {
    getAsset(tokenId: $tokenId, storeId: $storeId) {
      title
    subtitle
    serialNo
    category
    price {
      type
      amount
      currency
      sale {
        salePrice
        saleEndDate
      }
      symbol
    }
    symbol
    attrs {
      name
      val
      disp_type
      disp_val
    }
    media {
      type
      src
      thumbnail
    }
    timeline {
      event
      date
      from {
        value
        link
      }
      to {
        value
        link
      }
      proof {
        value
        link
      }
    }
    }
  }
`;
